<div appModal mainClass="lg-modal" (closeModal)="close()">
  <div class="form-container">
    <section class="modal-title-container">
      <div class="modal--title">Upload your game</div>
      <div class="modal--subtitle">Drag and drop your file here and add your game info in the fields below.</div>
    </section>

    <section class="modal-content-container">
      <div class="upload-container">
        <div
          class="thumbnail-container video-thumbnail-container flex justify-center items-center"
          [class.file-loaded]="file"
          [class.file-drag]="fileDrag"
          (drop)="onDrop($event)"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
        >
          <ng-container *ngIf="!file && !uploading">
            <svg-icon src="/assets/images/svg/icons/misc/hr-upload.svg"></svg-icon>
            <p>
              <span class="mx-5"> .MOV </span>
              <span class="mx-5"> .MP4 </span>
              <span class="mx-5"> .MPEG </span>
            </p>
            <p class="text-gray text-base mb-20">Maximum file size is 500MB</p>
            <p class="text-gray text-base text-center">
              You can also attach by <br />
              <a (click)="videoUpload.click()">clicking here</a>
            </p>
          </ng-container>

          <ng-container *ngIf="file && !uploading">
            <svg-icon src="/assets/images/svg/icons/misc/hr-upload-active.svg"></svg-icon>
            <p class="text-center">
              {{ file?.name }}<br />
              <a class="text-base" (click)="resetFile()"> Remove file </a>
            </p>
          </ng-container>

          <ng-container *ngIf="uploading">
            <p class="text-progress">{{ uploadProgress }}%</p>

            <div class="progress-bar">
              <div [style.width.%]="uploadProgress"></div>
            </div>

            <p class="text--dark text-center">
              Your video is uploading.
              <br />
              Please Wait.
            </p>
          </ng-container>
        </div>

        <input
          type="file"
          accept="video/*"
          name="video-upload"
          id="video-upload"
          #videoUpload
          (change)="fileChanged($event)"
        />

        <div class="input-group__fields mb-30" [formGroup]="newGameForm">
          <label class="input-title required">Game title</label>
          <div class="input input-text" [class.input-error]="formHelpersService.isInputInvalid(newGameForm, 'title')">
            <input type="text" placeholder="Game title" formControlName="title" />
          </div>

          <label class="input-title required">Name of event</label>
          <ng-select
            [items]="eventsList"
            bindLabel="name"
            bindValue="id"
            placeholder="Name of event"
            [minTermLength]="2"
            typeToSearchText="Please enter 2 or more characters"
            [typeahead]="eventInput$"
            (change)="onEventSelect($event)"
            (search)="onNewEvent($event)"
            notFoundText="No events found"
            class="normal-white mb-10 hide-arrow"
            [isOpen]="eventListOpened"
            [class.input-error]="formHelpersService.isInputInvalid(newGameForm, 'event', searchTerm)"
            (clickOutside)="onEventClickOutside($event)"
            [clickOutsideEvents]="'click,touchstart'"
            [excludeBeforeClick]="true"
            [delayClickOutsideInit]="true"
            [attachOutsideOnClick]="true"
          >
            <ng-template ng-loadingspinner-tmp>
              <div class="loader mr-5">
                <div class="ball1"></div>
                <div class="ball2"></div>
                <div class="ball3"></div>
              </div>
            </ng-template>
          </ng-select>

          <label class="input-title required">Event data</label>
          <div
            class="input input-text"
            [class.input-error]="formHelpersService.isInputInvalid(newGameForm, 'eventDate')"
          >
            <input appDateFormat type="text" formControlName="eventDate" placeholder="MM/DD/YY" />
          </div>
          <label class="input-title required">Event time</label>
          <div class="time-input-container">
            <div
              [class.input-error]="formHelpersService.isInputInvalid(newGameForm, 'eventTime')"
              class="input input-text"
            >
              <input appTimeFormat type="text" formControlName="eventTime" placeholder="00:00" />
            </div>
            <ng-select
              class="ml-10"
              [items]="meridians"
              bindLabel="name"
              bindValue="value"
              [searchable]="false"
              [clearable]="false"
              formControlName="selectedMeridian"
            >
            </ng-select>
          </div>
        </div>
      </div>
    </section>

    <section class="modal-actions-container">
      <p class="text-sienna" *ngIf="invalidFile">The selected file is invalid.</p>
      <button alt="Cancel" class="btn btn-lg btn-grey" (click)="close()">Cancel</button>
      <button
        alt="Save"
        class="btn btn-lg"
        (click)="save()"
        [disabled]="!file || formHelpersService.isInputInvalid(newGameForm, 'title') || uploading"
        [class.btn-disabled]="!file || formHelpersService.isInputInvalid(newGameForm, 'title') || uploading"
      >
        Add Video
      </button>
    </section>
  </div>
</div>
